const spanish = {
  processing: 'Procesando...',
  search: 'Buscar:',
  lengthMenu: 'Mostrar _MENU_ elementos',
  info: 'Mostrando desde _START_ al _END_ de _TOTAL_ elementos',
  infoEmpty: 'Mostrando ningún elemento.',
  infoFiltered: '(filtrado _MAX_ elementos total)',
  infoPostFix: '',
  loadingRecords: 'Cargando registros...',
  zeroRecords: 'No se encontraron registros',
  emptyTable: 'No hay datos disponibles en la tabla',
  paginate: {
    first: 'Primero',
    previous: 'Anterior',
    next: 'Siguiente',
    last: 'Último'
  },
  aria: {
    sortAscending: ': Activar para ordenar la tabla en orden ascendente',
    sortDescending: ': Activar para ordenar la tabla en orden descendente'
  },
  buttons: {
    copyTitle: 'Datos copiados',
    copyKeys: 'Utilice el teclado o el menú para seleccionar el comando de copia',
    copySuccess: {
      1: 'Copiada una fila en el portapapeles',
      _: 'Copiadas %d filas en el portapapeles'
    },
  }
};

export {
  spanish
};



// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/interfaces/datatables.es.ts